import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { asignarPDFCostosComponent } from './asignarPDFCostos.component';

import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'asignarPDFCostos',
        component: asignarPDFCostosComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'asignarPDFCostos',
          nombreFormulario : 'asignar PDF Costos'
        } 
    }
];

@NgModule({
    declarations: [
        asignarPDFCostosComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        asignarPDFCostosComponent
    ],
    bootstrap: [asignarPDFCostosComponent]
})

export class asignarPDFCostosModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CrearEscritura/asignarPDFCostos.module.ts